---
fr:
  admin:
    time_series_trackers:
      by_source:
        ago: il y a {time}
        columns:
          latest_reading: Dernière mesure connue
          plants: Centrales
          source: Source
          status: Statut
        load_error: Impossible de charger l'état des sources.
        never: Jamais
        no_plants: Aucune centrale active configurée pour cette source.
        no_sources: Aucune source trouvée.
        plant_columns:
          latest_reading: Dernière mesure
          plant: Centrale
          signal: Signal
          status: Statut
        refresh: Actualiser
        search_placeholder: Rechercher une centrale
        show_empty: Afficher les sources sans centrale
        signal:
          all: Tous les signaux
          heartbeat: Battement du capteur
          volume: Volume
        status:
          delayed: En retard
          down: Hors service
          no_data: Aucune donnée
          up: Actif
        subtitle: Indique si chaque source de données active émet ou s'est arrêtée.
        title: État des sources de données
      tabs:
        by_series: Par série
        by_source: Par source
